export function FullScreenSpinner({ label }: { label: string }) {
  return (
    /*
      `auth-bg` here too: these spinners are what you see between the login page and the
      board, and dropping to a bare canvas for that second reads as the page breaking.
      Inside the app the shell paints over it, so it costs nothing there.
    */
    <div className="auth-bg flex h-full flex-col items-center justify-center gap-3" role="status">
      <div
        className="size-6 animate-spin rounded-full border-2 border-current border-t-transparent opacity-40"
        aria-hidden
      />
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
        {label}…
      </p>
    </div>
  );
}
